import UdeskLocales from 'UdeskLocales';
import React, { FC, memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Button, Form, Input, message, Space, Spin } from 'udesk-ui';
import { FormWrapper, Logo, TipWrapper, Wrapper } from './components';
import Authorization from 'Component/pages/system-integration/components/Authorization';
import { getZendeskConfigsChat } from 'src/api/zendeskConfigs/chat';
import { postZendeskConfigsChatSaveAndAuth } from 'src/api/zendeskConfigs/chat/saveAndAuth';
import { putZendeskConfigsChatCancelAuth } from 'src/api/zendeskConfigs/chat/cancelAuth';
import { postZendeskConfigsChatAuth } from 'src/api/zendeskConfigs/chat/auth';
import { ZendeskConfigChatAuthRequest } from 'src/api/types';

interface FormValues
    extends Pick<
        ZendeskConfigChatAuthRequest,
        'chatClientId' | 'chatClientSecret' | 'chatSubdomain' | 'chatRedirectUri'
    > {}

interface TempalteProps {}

const Tempalte: FC<TempalteProps> = memo((props) => {
    const locales = UdeskLocales['current'];

    const [form] = Form.useForm();

    const [initFormValues, setInitFormValues] = useState<FormValues>();

    const [authorized, setAuthorized] = useState(false);

    const {
        run: refresh,
        loading: getLoading,
        data,
    } = useRequest(() => getZendeskConfigsChat({}), {
        onSuccess: (res) => {
            setAuthorized(res.data?.chatStatus === 1);
            setInitFormValues({
                chatClientId: res.data?.chatClientId,
                chatClientSecret: res.data?.chatClientSecret,
                chatSubdomain: res.data?.chatSubdomain,
                chatRedirectUri: window.location.href,
            });
            form.resetFields();
        },
    });

    const { run: onFinish, loading: saveLoading } = useRequest(
        (values: FormValues) =>
            postZendeskConfigsChatSaveAndAuth({ ...values, id: data?.data?.id }),
        {
            manual: true,
            onSuccess: (res) => {
                if (res.data) {
                    window.open(res.data, '_blank');
                }
            },
        }
    );

    const query = new URLSearchParams(window.location.search);
    const code = query.get('code');

    const { loading: authLoading } = useRequest(
        () => postZendeskConfigsChatAuth({ params: { code: code! } }),
        {
            ready: !!code,
            onSuccess: () => {
                message.success(/* 授权成功 */UdeskLocales['current'].pages.systemIntegration.zendesk.components.chat.index.authorizationSucceeded);
                refresh();
            },
        }
    );

    const { run: cancelAuth, loading: putLoading } = useRequest(
        () => putZendeskConfigsChatCancelAuth({}),
        {
            manual: true,
            onSuccess: () => {
                message.success(/* 取消授权成功 */UdeskLocales['current'].pages.systemIntegration.zendesk.components.chat.index.cancelAuthorizationSuccessfully);
                refresh();
            },
        }
    );

    return (
        <Wrapper>
            <TipWrapper>
                <Authorization authorized={authorized} />
            </TipWrapper>

            <Spin spinning={getLoading || saveLoading || authLoading || putLoading}>
                <FormWrapper>
                    <Logo className="logo">
                        <img src="/static/images/zendesk.webp" alt="" style={{ width: '100%' }} />
                    </Logo>

                    <Form
                        form={form}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 10 }}
                        initialValues={initFormValues}
                        onFinish={onFinish}
                        style={{ flex: 1 }}
                    >
                        <Form.Item name="chatClientId" label={/* 客户端ID */UdeskLocales['current'].pages.systemIntegration.zendesk.components.chat.index.clientID}>
                            <Input disabled={authorized} />
                        </Form.Item>

                        <Form.Item name="chatClientSecret" label={/* 客户端密钥 */UdeskLocales['current'].pages.systemIntegration.zendesk.components.chat.index.clientKey}>
                            <Input disabled={authorized} />
                        </Form.Item>

                        <Form.Item name="chatSubdomain" label="Subdomain">
                            <Input disabled={authorized} />
                        </Form.Item>

                        <Form.Item name="chatRedirectUri" label={/* 重定向URL */UdeskLocales['current'].pages.systemIntegration.zendesk.components.chat.index.redirectURL}>
                            <Input disabled />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 5, span: 10 }}>
                            {!authorized ? (
                                <Space>
                                    <Button key="applyAuth" type="primary" htmlType="submit">
                                        {locales.pages.admin.systemIntegration.applyAuth}
                                    </Button>
                                </Space>
                            ) : (
                                <Space>
                                    <Button key="cancelAuth" onClick={() => cancelAuth()}>
                                        {locales.pages.admin.systemIntegration.cancelAuth}
                                    </Button>
                                </Space>
                            )}
                        </Form.Item>
                    </Form>
                </FormWrapper>
            </Spin>
        </Wrapper>
    );
});

export default Tempalte;
